import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';
import * as types from './Types.js';

const initialState = fromJS({
  emendas: { content: [] },
  emenda: {},
  tiposOrigens: [],
  tiposTransferencias: [],
  movimentacoes: { content: [] },
  totalizador: {}
});

function emendaContabilidadeReducer(state = initialState, action) {
  switch (action.type) {
    case types.CONSULTA_EMENDAS_MUNICIPAIS_START:
    case types.CONSULTA_EMENDAS_MUNICIPAIS_TOTAL_START:
    case types.CONSULTA_EMENDAS_FEDERAIS_START:
    case types.CONSULTA_EMENDAS_FEDERAIS_TOTAL_START:
    case types.CONSULTA_EMENDAS_ESTADUAIS_START:
    case types.CONSULTA_EMENDAS_ESTADUAIS_TOTAL_START:
    case types.EMENDA_START:
    case types.EMENDA_MOVIMENTACAO_START:
    case types.TIPO_TRANSFERENCIA_START:
    case types.TIPO_ORIGEM_START: {
      return startLoad(state);
    }

    case types.CONSULTA_EMENDAS_MUNICIPAIS_ERROR:
    case types.CONSULTA_EMENDAS_MUNICIPAIS_TOTAL_ERROR:
    case types.CONSULTA_EMENDAS_FEDERAIS_ERROR:
    case types.CONSULTA_EMENDAS_FEDERAIS_TOTAL_ERROR:
    case types.CONSULTA_EMENDAS_ESTADUAIS_ERROR:
    case types.CONSULTA_EMENDAS_ESTADUAIS_TOTAL_ERROR:
    case types.EMENDA_ERROR:
    case types.EMENDA_MOVIMENTACAO_ERROR:
    case types.TIPO_TRANSFERENCIA_ERROR:
    case types.TIPO_ORIGEM_ERROR: {
      return endLoad(state);
    }

    case types.CONSULTA_EMENDAS_MUNICIPAIS_SUCCESS:
    case types.CONSULTA_EMENDAS_FEDERAIS_SUCCESS:
    case types.CONSULTA_EMENDAS_ESTADUAIS_SUCCESS: {
      return endLoad(state.set('emendas', fromJS(action.payload)));
    }

    case types.CONSULTA_EMENDAS_MUNICIPAIS_TOTAL_SUCCESS:
    case types.CONSULTA_EMENDAS_FEDERAIS_TOTAL_SUCCESS:
    case types.CONSULTA_EMENDAS_ESTADUAIS_TOTAL_SUCCESS: {
      return endLoad(state.set('totalizador', fromJS(action.payload)));
    }

    case types.EMENDA_MOVIMENTACAO_SUCCESS: {
      return endLoad(state.set('movimentacoes', fromJS(action.payload)));
    }

    case types.EMENDA_SUCCESS: {
      return endLoad(state.set('emenda', fromJS(action.payload)));
    }

    case types.TIPO_TRANSFERENCIA_SUCCESS: {
      return endLoad(state.set('tiposTransferencias', fromJS(action.payload)));
    }

    case types.TIPO_ORIGEM_SUCCESS: {
      return endLoad(state.set('tiposOrigens', fromJS(action.payload)));
    }

    case types.RESET_CONSULTA_EMENDAS: {
      return initialState;
    }
  }

  return state;
}

export default emendaContabilidadeReducer;
